import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo, faqs } from '@/mocks/siteData';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'kaiyun.com 官方登录入口与完整使用指南',
            description: siteInfo.description,
            url: siteInfo.url,
            isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: siteInfo.url },
            inLanguage: 'zh-CN',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'kaiyun.com',
            url: siteInfo.url,
            description: siteInfo.description,
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'support@kaiyun.com',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />

      <HeroSection />
      <FeatureSection />
      <CategorySection />
      <ArticleSection />
      <FAQSection />
      <CTASection />
    </>
  );
}